/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Savechanges1Inputs */

const he_common_savechanges1 = /** @type {(inputs: Common_Savechanges1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שמור שינויים`)
};

const en_common_savechanges1 = /** @type {(inputs: Common_Savechanges1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Changes`)
};

/**
* | output |
* | --- |
* | "Save Changes" |
*
* @param {Common_Savechanges1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const common_savechanges1 = /** @type {((inputs?: Common_Savechanges1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Savechanges1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_savechanges1(inputs)
	return en_common_savechanges1(inputs)
});
export { common_savechanges1 as "common_saveChanges" }